import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faExternalLinkAlt} from "@fortawesome/free-solid-svg-icons";
import React from "react";

interface ConsignmentTrackingPortalButtonProps {
    consignment: CustomerAPIConsignmentResponse
}

const ConsignmentTrackingPortalButton = ({
    consignment
}: ConsignmentTrackingPortalButtonProps) => {

    const openWindow = (e: React.MouseEvent) => {
        e.stopPropagation();
        window.open(consignment.trackingPortalLink);
    };

    return (
        <button onClick={openWindow} className="btn btn-sm btn-outline-primary">
            <FontAwesomeIcon icon={faExternalLinkAlt} />
        </button>
    );

}

export default ConsignmentTrackingPortalButton;
